<template>
  <div>
    <!-- Page header -->
    <CCard class="mb-4">
      <CCardBody class="p-4">
        <CButton color="link" class="px-0 mb-2" @click="onBack">
          <CIcon name="cil-arrow-left" class="mr-1" /> Branding
        </CButton>
        <h1 class="h4 mb-1">Edit branding</h1>
        <p class="text-muted mb-0">Change your custom domain, logo and browser icon</p>
      </CCardBody>
    </CCard>

    <CCard>
      <div v-if="loading" class="text-center p-5">
        <CSpinner color="primary" />
      </div>
      <div v-else-if="error" class="text-center p-5">
        <CIcon name="cil-warning" size="xl" class="text-danger mb-2" />
        <h2 class="h6">Couldn't load your branding</h2>
        <p class="text-muted">Check your connection and try again.</p>
        <CButton color="primary" variant="outline" @click="resetObj">
          <CIcon name="cil-reload" /> Retry
        </CButton>
      </div>
      <template v-else>
        <CCardBody>
          <CForm @submit.prevent="onUpdate">
            <CRow form>
              <CCol md="6">
                <CInput
                  v-if="obj.tenant"
                  label="Custom domain (optional)"
                  v-model="obj.tenant.domainName"
                  placeholder="app.yourbusiness.com.my"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol md="6"
                ><CFormGroup wrapperClasses="input-group pt-2">
                  <template #label> Logo </template>
                  <template #input>
                    <div class="w-100">
                      <CRow>
                        <CCol sm="6">
                          <CImg
                            :src="getLogoUrl()"
                            alt="Business logo"
                            class="mb-2"
                            thumbnail
                            responsive
                          />
                        </CCol>
                        <CCol sm="6"
                          ><WidgetsUploadImage @uploaded="logo_uploaded"
                        /></CCol>
                      </CRow>
                    </div>
                  </template> </CFormGroup
              ></CCol>
              <CCol md="6"
                ><CFormGroup wrapperClasses="input-group pt-2">
                  <template #label> Browser icon (favicon) </template>
                  <template #input>
                    <div class="w-100">
                      <CRow>
                        <CCol sm="6">
                          <CImg
                            :src="getFavIconUrl()"
                            alt="Browser icon"
                            class="mb-2"
                            thumbnail
                            responsive
                          />
                        </CCol>
                        <CCol sm="6"
                          ><WidgetsUploadImage @uploaded="icon_uploaded"
                        /></CCol>
                      </CRow>
                    </div>
                  </template> </CFormGroup
              ></CCol>
            </CRow>
          </CForm>
        </CCardBody>
        <CCardFooter class="d-flex justify-content-between">
          <CButton color="light" :disabled="saving" @click="onBack">Cancel</CButton>
          <CButton color="primary" :disabled="saving" @click="onUpdate">
            <CSpinner v-if="saving" size="sm" class="mr-1" />
            Save
          </CButton>
        </CCardFooter>
      </template>
    </CCard>
  </div>
</template>

<script>
import BrandingApi from "../../lib/brandingApi";
import WidgetsUploadImage from "../widgets/WidgetsUploadImage";

export default {
  name: "BrandingEdit",
  components: {
    WidgetsUploadImage,
  },
  data() {
    return {
      loading: true,
      error: false,
      saving: false,
      api: new BrandingApi(),
      obj: {},
    };
  },
  mounted() {
    this.resetObj();
  },

  methods: {
    logo_uploaded(data) {
      this.obj.logoUrl = "/Documents/File/" + data.uploadedFiles[0].id;
    },
    icon_uploaded(data) {
      this.obj.faviconUrl = "/Documents/File/" + data.uploadedFiles[0].id;
    },
    removeTrailingSlash(str) {
      if (str.endsWith("/")) {
        return str.slice(0, -1);
      }
      return str;
    },
    getFavIconUrl() {
      return this.removeTrailingSlash(apiUrl) + this.obj.faviconUrl;
    },
    getLogoUrl() {
      return this.removeTrailingSlash(apiUrl) + this.obj.logoUrl;
    },
    onBack() {
      this.$router.push({
        path: `/tenants/branding`,
      });
    },
    onUpdate() {
      var self = this;
      if (self.saving) return;
      self.saving = true;
      self.api
        .update(self.obj)
        .then(() => {
          self.$toast.success("Branding saved");
          self.$router.push({
            path: `/tenants/branding`,
          });
        })
        .catch(({ data }) => {
          self.$toast.error(
            `Couldn't save your branding. ${helper.getErrorMessage(data)}`
          );
        })
        .finally(() => {
          self.saving = false;
        });
    },
    resetObj() {
      var self = this;
      self.loading = true;
      self.error = false;
      this.api
        .getByCurrentUser()
        .then((response) => {
          self.obj = response.result || {};
        })
        .catch((err) => {
          console.error(err);
          self.error = true;
        })
        .finally(() => {
          self.loading = false;
        });
    },
  },
};
</script>
